<template>
  <div>
    <el-table :id="`${name}`"
              :class="`${name}`"
              :data="computedData"
              border
              v-loading="isLoading"
              :row-class-name="({ row }) => row.id"
              :row-key="row => row.id"
              :expand-row-keys="expandRowKeys"
              @expand-change="handleSelectTeam"
              size="mini"
              :fit="true">
      <!--ref="tableData"
              :row-class-name="({ row }) => row.id"
              @row-click="handleList"-->
      <el-table-column type="expand" :column-key="`${'expand'}`">
        <template slot-scope="props">
          <el-tabs type="card">
            <el-tab-pane label="권한 상세 보기">
              <h4>
                {{selectTeam.name}}
                {{selectTeam.explain}}
              </h4>
              <div class="permission">
                <div v-for="(service, serviceId) in selectTeam.viewData"
                     v-if="selectTeam.available_services.includes(serviceId)"
                     :key="`service_${serviceId}`">
                  <h3 style="padding: 3px; background-color: #eee;">{{services[serviceId].name}}</h3>
                  <el-row :gutter="24">
                    <el-col v-for="(range) in service.permissionList"
                            :key="range"
                            :xs="8" :sm="6" :md="4" :lg="3" :xl="1">
                      <div>
                        <span>{{services[serviceId].range_group[range].full_name}}</span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="수정">
              <strong>사용 할 서비스:</strong>
              <br>
              <br>
              <el-select v-model="selectTeam.available_services"
                         size="mini"
                         multiple
                         filterable
                         allow-create
                         default-first-option
                         @change="handleAvailableServices"
                         placeholder="서비스 선택" style="width: 100%">
                <el-option v-for="(service, serviceId) in selectTeam.permissions"
                           :key="serviceId"
                           :label="serviceId"
                           :value="serviceId">
                </el-option>
              </el-select>
              <br>
              <br>
              <strong>팀원의 접근 가능 도메인수정</strong>
              <br>
              <br>
              <el-tabs tab-position="left"
                       v-model="activeName">
                <el-tab-pane v-for="(service, serviceId) in selectTeam.viewData"
                             :disabled="!selectTeam.available_services.includes(serviceId)"
                             :key="`${selectTeam.id}_${serviceId}`"
                             :name="serviceId"
                             :label="serviceId">
                  <el-card class="box-card"
                           shadow="hover">
                    <el-radio-group v-model="service.checkTag">
                      <el-radio label="">Tag 사용 안함</el-radio>
                      <el-radio v-for="(tag, key) in service.tags"
                                :key="`tag_${key}`"
                                :label="key"
                                @change="handleCheckTag(key, serviceId, service.checkTag, $event)">
                        #{{key}}
                      </el-radio>
                    </el-radio-group>
                  </el-card>
                  <br>
                  <el-checkbox-group v-model="service.permissionList">
                    <el-checkbox v-for="(item, key) in service.domainList"
                                 :key="`item_${key}`"
                                 :label="item"
                                 :disabled="service.selectedPermissionsByTag.includes(item)"/>
                  </el-checkbox-group>
                </el-tab-pane>
              </el-tabs>
              <div>
                <el-button @click="handleEditTeam(selectTeam)"
                           size="mini"
                           type="warning">저장 하기</el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="팀소속 팀원">
              <ul>
                <li v-for="(member, index) in getHasTeamMember(selectTeam)"
                    :key="index">
                  {{member.team}}팀 :
                  {{member.name}}( {{member.id}} )
                </li>
              </ul>
              <div>
                <div v-if="isAddMemberCompany(selectTeam)">
                  <br>이메일:
                  <el-input size="mini"
                            placeholder="이메일 입력"
                            style="width: 200px"
                            v-model="addMemberEmail"></el-input>
                  <el-button @click="handleAddTeamMember(selectTeam)"
                             size="mini"
                             type="warning">팀원 추가 하기</el-button>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>

      </el-table-column>
      <template v-for="(key) in localIndicator">
        <el-table-column :prop="`${key}`"
                         :key="key"
                         :label="key"
                         :sortable="true"
                         :column-key="key">
          <template slot-scope="scope">
            <template v-if="key === 'available_services'">
              <span v-for="(serviceId) in scope.row[key]"
                    :key="serviceId">
                {{services[serviceId].name}},
              </span>
            </template>
            <template v-else-if="key === 'group'">
              {{{}.hasOwnProperty.call(groups, scope.row.group) ? groups[scope.row.group].name : scope.row.group}}그룹
            </template>
            <template v-else>
              {{scope.row[key]}}
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateTeam from '@/components/CreateTeam';
import filterTeamView from '@/filters/getTeamViewData';
// import filterJobView from '@/filters/getJobViewData';

export default {
  filters: {
    filterTeamView,
    // filterJobView,
  },
  components: {
    CreateTeam,
  },
  computed: {
    ...mapGetters([
      'base',
      'isLoading',
      'members',
      'groups',
      'services',
      // 'jobs',
      'teams',
      'companies',
    ]),
    computedData() {
      const teamList = [];

      Object.keys(this.teams).forEach((teamId) => {
        teamList.push(this.teams[teamId]);
      });
      return teamList;
    },
  },
  methods: {
    handleSelectTeam(row) {
      this.handleExpandChange(row);
      this.selectedTeamSetting(row);
    },

    handleExpandChange(row) {
      const id = row.id;
      const lastId = this.expandRowKeys[0];

      this.expandRowKeys = id === lastId ? [] : [id];
    },

    selectedTeamSetting(row, isUpdate) {
      if (this.selectedMember) {
        if (this.selectedMember.id !== row.id) {
          this.makeTeamViewData(row);
        } else if (isUpdate) {
          this.makeTeamViewData(row, isUpdate);
        } else {
          this.makeTeamViewData(null);
        }
      } else {
        this.makeTeamViewData(row);
      }
      // if (this.selectedRow) {
      //   if (this.selectedRow.id !== row.id) {
      //     this.$refs.tableData.toggleRowExpansion(this.selectedRow);
      //     // this.makeTeamPermissionData(row);
      //     this.makeSelectRowViewData(row);
      //     this.$refs.tableData.toggleRowExpansion(row);
      //     this.selectedRow = row;
      //   } else {
      //     this.$refs.tableData.toggleRowExpansion(row);
      //     this.selectedRow = null;
      //   }
      // } else {
      //   // this.makeTeamPermissionData(row);
      //   this.makeSelectRowViewData(row);
      //   this.$refs.tableData.toggleRowExpansion(row);
      //   this.selectedRow = row;
      // }
    },

    makeTeamViewData(row) {
      this.selectTeam = filterTeamView.setTeamView(row, this.services, this.jobs, this.teams);
      this.activeName = this.selectTeam.available_services[this.selectTeam.available_services.length - 1];
    },

    isAddMemberCompany(selectTeam) {
      let isCompanyType = false;

      Object.keys(this.companies).forEach((header) => {
        if (selectTeam.company === this.companies[header].id && this.companies[header].type > 2) {
          isCompanyType = true;
        }
      });
      return isCompanyType;
    },
    // makeSelectRowViewData(row) {
    //   this.selectTeam = filterTeamView.setTeamView(row, this.services, this.jobs, this.teams);
    //   this.activeName = this.selectTeam.available_services[0];
    // },

    handleCheckTag(key, serviceId) {
      const viewData = this.selectTeam.viewData;

      viewData[serviceId].selectedPermissionsByTag = viewData[serviceId].tags[key];
      viewData[serviceId].permissionList = viewData[serviceId].tags[key];
    },

    handleEditTeam(selectTeamData) {
      const returnData = JSON.parse(JSON.stringify(selectTeamData));

      Object.keys(selectTeamData.viewData).forEach((serviceId) => {
        const checkTag = selectTeamData.viewData[serviceId].checkTag;

        returnData.permissions[serviceId] = [];
        selectTeamData.viewData[serviceId].permissionList.forEach((item) => {
          if (!selectTeamData.viewData[serviceId].selectedPermissionsByTag.includes(item)) {
            returnData.permissions[serviceId].push(item);
          }
        });
        if (checkTag !== '') {
          returnData.permissions[serviceId].push(`tag:${selectTeamData.viewData[serviceId].checkTag}`);
        }
      });

      delete returnData.viewData;
      delete returnData.division;

      this.$store.dispatch('SUBMIT_TEAM_EDIT_DATA', returnData);
    },

    moveScroll(row) {
      window.scrollTo({
        top: document.querySelector(`.${row.id}`).offsetTop,
        behavior: 'smooth',
      });
    },

    // handleList(row, target) {
    //   if (target === 'top') {
    //     this.setScroll(0);
    //   }
    //   this.rowClicked(row);
    // },

    // rowClicked(row, isSearch, isUpdate) {
    //   if (this.selectedRow) {
    //     if (this.selectedRow.id !== row.id) {
    //       this.$refs.tableData.toggleRowExpansion(this.selectedRow);
    //       // this.makeTeamPermissionData(row);
    //       this.makeSelectRowViewData(row);
    //       this.$refs.tableData.toggleRowExpansion(row);
    //       this.selectedRow = row;
    //     } else if (isSearch) {
    //       if (isUpdate) {
    //         // this.makeTeamPermissionData(row);
    //         this.makeSelectRowViewData(row);
    //         this.$refs.tableData.toggleRowExpansion(row);
    //         this.selectedRow = row;
    //       } else {
    //         this.selectedRow = row;
    //       }
    //     } else {
    //       this.$refs.tableData.toggleRowExpansion(row);
    //       this.selectedRow = null;
    //     }
    //   } else {
    //     // this.makeTeamPermissionData(row);
    //     this.makeSelectRowViewData(row);
    //     this.$refs.tableData.toggleRowExpansion(row);
    //     this.selectedRow = row;
    //   }
    // },

    getPartsListByJob() {
      // return filterJobView.getPartsListByJob(this.jobs);
    },

    getPartsListByRange(currentTeam) {
      return filterTeamView.getPartsListByRange(this.services, currentTeam);
    },

    handleAvailableServices() {
      Object.keys(this.selectTeam.permissions).forEach((serviceId) => {
        if (!this.selectTeam.available_services.includes(serviceId)) {
          this.selectTeam.permissions[serviceId] = [];
        }
      });
      this.makeTeamViewData(this.selectTeam);
    },

    // handleRangePart(parts) {
    //   Object.keys(this.selectTeam.permissions).forEach((serviceId) => {
    //     // 파트를 선택 하면 기존의 것에 있으면 두고 없으면 추가 한다.
    //     if (this.selectTeam.available_services.includes(serviceId)) {
    //       parts.forEach((part) => {
    //         const tag = `tag:${part}`;
    //
    //         if (!this.selectTeam.permissions[serviceId].includes(tag)) {
    //           this.selectTeam.permissions[serviceId].push(tag);
    //         }
    //       });
    //     }
    //   });
    //   this.makeTeamViewData(this.selectTeam);
    // },

    getHasTeamMember(selectTeam) {
      const memberLIst = [];

      this.members.forEach((member) => {
        Object.keys(member.affiliatedTeams).forEach((teamId) => {
          const team = member.affiliatedTeams[teamId];

          if (team.id === selectTeam.id) {
            memberLIst.push({
              id: member.id,
              name: member.name,
              team: selectTeam.name,
            });
          }
        });
      });

      return memberLIst;
    },

    handleRemoveTeam(selectTeam) {
      if (this.getHasTeamMember(selectTeam).length === 0) {
        this.$store.dispatch('SUBMIT_TEAM_REMOVE_DATA', {
          id: selectTeam.id,
        });
      } else {
        alert('이 팀에 속한 사용자가 있습니다. 사용자를 삭제 하고 다시 시도해 주세요.');
      }
    },
    // isAddMemberCompany(selectTeam) {
    //   let isCompanyType = false;
    //
    //   Object.keys(this.companies).forEach((header) => {
    //     if (selectTeam.company === this.companies[header].id && this.companies[header].type > 2) {
    //       isCompanyType = true;
    //     }
    //   });
    //   return isCompanyType;
    // },
    handleAddTeamMember(selectTeam) {
      this.$store.dispatch('SUBMIT_ADD_MEMBER_TO_TEAM_DATA', {
        id: selectTeam.id,
        email: this.addMemberEmail,
      });
    },
    // getParts() {
    //   const parts = [];
    //   const jobParts = {
    //     label: 'job',
    //     options: [],
    //   };
    //   const rangeParts = {
    //     label: 'range',
    //     options: [],
    //   };
    //
    //   Object.keys(this.jobs).forEach((jobId) => {
    //     const job = this.jobs[jobId];
    //
    //     if (!jobParts.options.includes(job.category)) {
    //       jobParts.options.push(job.category);
    //     }
    //   });
    //
    //   Object.keys(this.services).forEach((servicesId) => {
    //     Object.keys(this.services[servicesId].range_group).forEach((itemId) => {
    //       this.services[servicesId].range_group[itemId].tag.forEach((tag) => {
    //         if (!rangeParts.options.includes(tag)) {
    //           rangeParts.options.push(tag);
    //         }
    //       });
    //
    //     })
    //   });
    //
    //   /*
    //   팀 수정에 사용
    //   Object.keys(this.teams).forEach((TeamId) => {
    //     Object.keys(this.teams[TeamId].permissions).forEach((serviceId) => {
    //       this.teams[TeamId].permissions[serviceId].forEach((item) => {
    //         const splitItem = item.split(':');
    //         const isTag = splitItem[0] === 'tag';
    //
    //         if (isTag && !rangeParts.options.includes(splitItem[1])) {
    //           rangeParts.options.push(splitItem[1]);
    //         }
    //       });
    //     })
    //   });
    //   */
    //   parts.push(rangeParts);
    //   parts.push(jobParts);
    //
    //   return parts
    // },
  },
  data() {
    return {
      name: 'TeamList',
      dialogVisible: false,
      addMemberEmail: '',
      localIndicator: [
        'group',
        'name',
        'available_services',
        // 'is_division',
        // 'part',
        // 'division',
      ],
      // 삭제 예정
      // currentIsDivision: false,
      // teamPermissionData: {},
      // 추가
      expandRowKeys: [],
      selectTeam: {},
      activeName: '',
      selectedRow: null,
      // newTeam: {
      //   company: '',
      //   group: '',
      //   name: '',
      //   explain: '',
      //   part: {
      //     job: [],
      //     range: [],
      //     custom: [],
      //   },
      //   available_services: [],
      //   is_division: false,
      //   permissions: {
      //     admin: [],
      //     bi: [],
      //     adi: [],
      //     mi: [],
      //     fmi: [],
      //     suntagent: [],
      //     authority: [],
      //   },
      // },
      // companys: [
      //   'sundaytoz',
      //   'playlinks',
      //   'disney',
      //   'kakao',
      // ],
      // companies: {
      //   // sundaytoz: {
      //   //   name: '선테이토즈',
      //   // },
      //   playlinks: {
      //     name: '플레이링스',
      //   },
      //   disney: {
      //     name: '디즈니',
      //   },
      //   kakao: {
      //     name: '카카오',
      //   },
      // },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TeamList.vue